import { render } from "./events-list-item.vue?vue&type=template&id=59e0a39e"
import script from "./events-list-item.vue?vue&type=script&lang=js"
export * from "./events-list-item.vue?vue&type=script&lang=js"

import "./events-list-item.vue?vue&type=style&index=0&id=59e0a39e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__